import React from 'react';
import { useNavigate } from 'react-router-dom';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();

  const handleLogin = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('Login button clicked!');
    
    // Set login status in localStorage
    localStorage.setItem('isLoggedIn', 'true');
    console.log('localStorage set:', localStorage.getItem('isLoggedIn'));
    
    // Force a page reload to trigger App.tsx useEffect
    window.location.href = '/home';
  };

  return (
    <div id="loginPage" className="login-page">
      {/* Full Screen Banner Background */}
      <div className="login-background"></div>
      
      {/* Gradient Overlay */}
      <div className="login-overlay"></div>
      
      {/* Login Modal */}
      <div className="login-container">
        <div className="login-modal">
          {/* JWIL Logo and Title */}
          <div className="login-header">
            <img src="/assets/images/jwil-logo.svg" alt="JWIL Logo" className="logo-image" />
          </div>
          
          {/* Welcome Text */}
          <div className="welcome-section">
            <h1 className="welcome-title">Welcome To JWIL Intranet Portal</h1>
            <p className="welcome-description">Please use existing Microsoft Office 365 credentials for Login to Intranet Portal</p>
          </div>
          
          {/* Login Button */}
          <button 
            id="loginButton" 
            className="login-button" 
            onClick={handleLogin}
            type="button"
            style={{
              cursor: 'pointer',
              pointerEvents: 'auto'
            }}
          >
            <img src="/assets/images/office-icon.svg" alt="Office Icon" />
            Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
